import { TFunction } from 'i18next'
import MasterKeyRestService from '../rest/MasterKeyRestService'

class MasterKeyService {
  static async get(setMasterkeyDetails: React.Dispatch<any>) {
    const masterkeyDetails = await MasterKeyRestService.get()
    setMasterkeyDetails(masterkeyDetails)
  }

  static async update(masterKeyFormData: any, t: TFunction, setMasterkeyDetails: React.Dispatch<any>) {
    try {
      var config = Object.assign({})
      config.methodName = masterKeyFormData.methodName
      if (masterKeyFormData.methodName === 'HSMRAM') {
        if (masterKeyFormData.ramPassword === masterKeyFormData.confirmPassword) {
          if (masterKeyFormData.hsmType === 'LUNA') {
            config.options = {
              hsmType: masterKeyFormData.hsmType,
              hsmPartition: masterKeyFormData.hsmPartition,
              ramPassword: masterKeyFormData.ramPassword,
              hsmPassword: masterKeyFormData.hsmPassword,
              hsmKeyAlias: masterKeyFormData.hsmKeyAlias,
            }
          } else if (masterKeyFormData.hsmType === 'UTIMACO') {
            config.options = {
              hsmType: masterKeyFormData.hsmType,
              hsmDevice: masterKeyFormData.hsmDevice,
              ramPassword: masterKeyFormData.ramPassword,
              hsmUsername: masterKeyFormData.hsmUsername,
              hsmPassword: masterKeyFormData.hsmPassword,
              hsmKeyAlias: masterKeyFormData.hsmKeyAlias,
              hsmKeyGroup: masterKeyFormData.hsmKeyGroup,
              hsmKeySpecifier: masterKeyFormData.hsmKeySpecifier,
            }
          }
        } else {
          const error = {
            message: t('masterkey.passwordsDoNotMatch'),
            statuscode: 400,
            level: 'ERROR',
          }
          return Promise.reject(error)
        }
      } else if (masterKeyFormData.methodName === 'HSMEPERI') {
        if (masterKeyFormData.hsmType === 'LUNA') {
          config.options = {
            hsmType: masterKeyFormData.hsmType,
            hsmPartition: masterKeyFormData.hsmPartition,
            hsmPassword: masterKeyFormData.hsmPassword,
            hsmKeyAlias: masterKeyFormData.hsmKeyAlias,
          }
        } else if (masterKeyFormData.hsmType === 'UTIMACO') {
          config.options = {
            hsmType: masterKeyFormData.hsmType,
            hsmDevice: masterKeyFormData.hsmDevice,
            hsmUsername: masterKeyFormData.hsmUsername,
            hsmPassword: masterKeyFormData.hsmPassword,
            hsmKeyAlias: masterKeyFormData.hsmKeyAlias,
            hsmKeyGroup: masterKeyFormData.hsmKeyGroup,
            hsmKeySpecifier: masterKeyFormData.hsmKeySpecifier,
          }
        }
      } else if (masterKeyFormData.methodName === 'RAM') {
        if (masterKeyFormData.ramPassword === masterKeyFormData.confirmPassword) {
          config.options = {
            ramPassword: masterKeyFormData.ramPassword,
          }
        } else {
          const error = {
            message: t('masterkey.passwordsDoNotMatch'),
            statuscode: 400,
            level: 'ERROR',
          }
          return Promise.reject(error)
        }
      } else {
        config = Object.assign({}, masterKeyFormData)
      }
      await MasterKeyRestService.updateMasterKeyConfig(config)
      await MasterKeyService.get(setMasterkeyDetails)
      return t('masterkey.yourChangesWereSuccessful')
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default MasterKeyService
